import defineMessages from "../../../../../../common/helpers/defineMessages";

const messages = defineMessages({
    width: {
        id: "tasks.melodyTable.width",
    },
    height: {
        id: "tasks.melodyTable.height",
    },
    position: {
        id: "tasks.melodyTable.position",
    },
    editScore: {
        id: "tasks.melodyTable.editScore",
    },
    stopEdit: {
        id: "tasks.stopEdit",
    },
    firstKnown: {
        id: "tasks.melodyTable.firstKnown",
    },
    createScoreTooltip: {
        id: "score.saveTooltip",
    },
    tonesetStaffNoKeyChange: {
        id: "tonesetStaff.noKeychange",
    },
});

export default messages;